import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_QBR_NAMESPACE = `${PARTNER360_NAMESPACE}/QBR`

// Async thunk constants
export const REQUEST_GENERATE_PPTX_DOCUMENT = `${PARTNER360_QBR_NAMESPACE}/requestGeneratePptxDocument`
export const REQUEST_QBR_DOCUMENT = `${PARTNER360_QBR_NAMESPACE}/requestQbrDocument`
export const REQUEST_QBR_PARTNERS = `${PARTNER360_QBR_NAMESPACE}/requestQbrPartners`
export const REQUEST_APPLY_CHANGES = `${PARTNER360_QBR_NAMESPACE}/requestApplyChanges`
export const REQUEST_RESET_DATA = `${PARTNER360_QBR_NAMESPACE}/requestResetData`
export const CREATE_DRAFT_QBR = `${PARTNER360_QBR_NAMESPACE}/createDraftQbr`
export const REQUEST_FINALIZE_DOCUMENT_WITHOUT_SAVING_CHANGES = `${PARTNER360_QBR_NAMESPACE}/requestFinalizeDocument`
